import React from 'react'
import { Link } from 'react-router-dom'
import SeoHead from '../components/SeoHead'
import WaveDivider from '../components/WaveDivider'
import { localizeTree } from '../i18n/localizeTree'

export default function ForbiddenPage({ lang = 'da' }) {
  return localizeTree((
    <>
      <SeoHead pageId="forbidden" lang="da" noIndex />

      <section className="min-h-[60vh] flex items-center justify-center py-20 px-6 sm:px-8">
        <div className="max-w-xl mx-auto text-center bg-white rounded-3xl p-8 sm:p-14 border border-[#C68D94]/20 shadow-sm">
          <span className="font-script text-6xl sm:text-7xl text-[#C68D94] font-normal block mb-2">
            403
          </span>
          <h1 className="font-script text-4xl sm:text-5xl text-[#3E3435] font-normal mb-3">
            Adgang nægtet
          </h1>
          <WaveDivider className="text-[#C68D94]/50 mx-auto mb-5" />
          <p className="text-xs sm:text-sm text-[#3E3435]/80 font-light leading-relaxed mb-8">
            Du har desværre ikke tilladelse til at tilgå denne del af hjemmesiden. Benyt venligst knapperne nedenfor til at navigere tilbage til de åbne sider.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="bg-[#C68D94] hover:bg-[#A35D67] text-white px-7 py-3 rounded-full text-xs font-semibold tracking-wider uppercase transition-colors shadow-sm"
            >
              Gå til forsiden
            </Link>
            <Link
              to="/aabningstider-og-adresse"
              className="border border-[#C68D94] text-[#A35D67] hover:bg-[#F7ECEE] px-7 py-3 rounded-full text-xs font-semibold tracking-wider uppercase transition-colors"
            >
              Kontakt os
            </Link>
          </div>
        </div>
      </section>
    </>
  ), lang)
}
